import { DirectiveOptions, VNode } from 'vue'
import { DirectiveBinding } from 'vue/types/options'
import { VBTooltip } from 'bootstrap-vue'

/**
 * Tooltip directive based on bootstrap tooltip directive
 * with hover as default trigger.
 */

interface HTMLElementWithBVTooltip extends HTMLElement {
    '__BV_Tooltip__': any
}

export const VVtTooltipAutoShow: DirectiveOptions = {
    ...VBTooltip, // extends the Bootstrap tooltip directive
    bind: (el: HTMLElement, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) => {
        binding.modifiers.hover = true

        const { bind } = VBTooltip
        if (bind) {
            bind(el, binding, vnode, oldVnode)
        }

        el.style.textOverflow = 'ellipsis'
        el.style.display = 'inline-block'
        el.style.whiteSpace = 'nowrap'
        el.style.overflow = 'hidden'

        el.addEventListener('mouseover', (evt: MouseEvent) => {
            let targetEl = evt.target as HTMLElementWithBVTooltip
            if (targetEl?.offsetWidth < targetEl?.scrollWidth) {
                targetEl.__BV_Tooltip__.disabled = false
            } else {
                targetEl.__BV_Tooltip__.disabled = true
            }
        })
    },
    componentUpdated: (el: HTMLElement, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) => {
        binding.modifiers.hover = true

        const { componentUpdated } = VBTooltip
        if (componentUpdated) {
            componentUpdated(el, binding, vnode, oldVnode)
        }
    }
}
